import { DOC_FIELD_TYPES } from 'constants/documentFieldTypes';

import { getOptionFieldTypeFromOption } from './documentFieldTypes';

export const getOptionDocumentExtracionFieldFromOption = ({ typeParentId, name, parentId }) => ({
  id: `${typeParentId}-${name}`,
  name,
  parentId,
  type: DOC_FIELD_TYPES.DROP_DOWN_FIELD,
  typeDefinition: getOptionFieldTypeFromOption({ parentId: typeParentId, name }),
});
